export enum GmailEvents {
  SentEmail = 'gmail.email.Sent'
}
